export default "__VITE_ASSET__PnnSgfBL__"